module.exports = __webpack_public_path__ + "img/jose-vega copy.5dbff173.png";